import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { getCookie } from '../../Utils/cookies';

const EditServicePerson = () => {
  const location = useLocation();
  const navigate = useNavigate();
   const empData = getCookie('empData') ? JSON.parse(getCookie('empData')) : {};
  const { state } = location;

  const {
    _id = '',
    name = '',
    email = '',
    contact = '',
    block,
    district = '',
    state: personState = '',
    longitude = '',
    latitude = '',
    
  } = state || {};

  const formatBlockForDisplay = (block) => {
    if (!block) return '';
    let finalBlock = "";
    if (Array.isArray(block)) {
      for(let i=0; i<block.length;i++){
        finalBlock += block[i];
        finalBlock += ",";
      }
    }
    return finalBlock;
  };
  console.log("final block ->", formatBlockForDisplay(block))
  const [formData, setFormData] = useState({
    servicePersonId: _id,
    name: name,
    email: email,
    contact: contact,
    block: formatBlockForDisplay(block),
    district: district,
    state: personState,
    longitude: longitude,
    latitude: latitude,
    updatedBy: empData?._id
  });

  const [loading, setLoading] = useState(false);

  if (!state) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-yellow-400">
        <div className="text-center">
          <p className="text-lg font-semibold mb-4">No service person data provided.</p>
          <button
            onClick={() => navigate(-1)}
            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.name || !formData.email || !formData.contact) {
      alert('Please fill in all required fields (Name, Email, Contact).');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.put(
        `https://api.inventory.galosolar.com/admin/update-service-person`,
        formData
      );
      alert(response?.data?.message || 'Update successful');
      navigate(-1);
    } catch (error) {
      alert(error.response?.data?.message || 'An error occurred');
      console.error('Update error:', error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-4 flex items-center justify-center">
      <div className="w-full ">
        <h1 className="text-2xl font-bold  mb-6 text-black">
          Update Service Person
        </h1>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-xl p-6">
          {/* Grid: 1 col on mobile, 3 cols on md+ */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Name */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                required
                className="w-full border border-gray-300 rounded-lg p-2 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                value={formData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
              />
            </div>

            {/* Email */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email <span className="text-red-600">*</span>
              </label>
              <input
                type="email"
                required
                className="w-full border border-gray-300 rounded-lg p-2 bg-gray-100 cursor-not-allowed focus:outline-none"
                value={formData.email}
                disabled
              />
            </div>

            {/* Contact */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact <span className="text-red-600">*</span>
              </label>
              <input
                type="tel"
                required
                className="w-full border border-gray-300 rounded-lg p-2 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                value={formData.contact}
                onChange={(e) => handleInputChange('contact', e.target.value)}
              />
            </div>

            {/* Working Block - Textarea with increased height */}
            <div className="col-span-1 md:col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Working Block <span className="text-gray-500 text-xs">(comma-separated)</span>
              </label>
              <textarea
                rows="3"
                className="w-full border border-gray-300 rounded-lg p-2 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent resize-vertical"
                value={formData.block}
                onChange={(e) => handleInputChange('block', e.target.value)}
                placeholder="e.g., Block1, Block2, Block3"
              />
              <p className="text-xs text-gray-500 mt-1">
                Separate multiple blocks with commas.
              </p>
            </div>

            {/* District */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">District</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded-lg p-2 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                value={formData.district}
                onChange={(e) => handleInputChange('district', e.target.value)}
              />
            </div>

            {/* State */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded-lg p-2 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                value={formData.state}
                onChange={(e) => handleInputChange('state', e.target.value)}
              />
            </div>

            {/* Longitude */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Longitude</label>
              <input
                type="number"
                step="any"
                className="w-full border border-gray-300 rounded-lg p-2 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                value={formData.longitude}
                onChange={(e) => handleInputChange('longitude', e.target.value)}
              />
            </div>

            {/* Latitude */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Latitude</label>
              <input
                type="number"
                step="any"
                className="w-full border border-gray-300 rounded-lg p-2 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                value={formData.latitude}
                onChange={(e) => handleInputChange('latitude', e.target.value)}
              />
            </div>

            {/* Empty div to balance last row */}
            <div className="hidden md:block col-span-1"></div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <button
              type="submit"
              disabled={loading}
              className={`flex-1 bg-black text-white font-bold py-2 rounded-lg transition duration-200 ${
                loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-800'
              }`}
            >
              {loading ? 'Updating...' : 'Update'}
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="flex-1 bg-red-500 text-white font-bold py-2 rounded-lg hover:bg-red-600 transition duration-200"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditServicePerson;